import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faClose,
} from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@client/new/components/basic';
import { Button } from '@client/components/common/inputs/Button';
import { moveArray } from '@client/components/landing-page-builder/helpers';
import { useFormContext } from 'react-hook-form';

type Bullet = {
  text: string;
};

type BulletInputProps = {
  name: string;
};
export function BulletsInput({ name }: BulletInputProps) {
  const { register, watch, setValue } = useFormContext();
  const r = (i: number) => register(`${name}.${i}.text`);
  const bullets = watch(name) || [];

  function onChange(newBullets: Bullet[]) {
    setValue(name, newBullets);
  }

  const removeBullet = (i: number) => {
    onChange([...bullets.slice(0, i), ...bullets.slice(i + 1)]);
  };

  const moveBullet = (from: number, to: number) => {
    onChange(moveArray(bullets, from, to));
  };

  const MAX_BULLET_LENGTH = 100;

  return (
    <section>
      {(bullets || []).map((x: Bullet, i: number) => {
        return (
          <div
            key={i}
            className="flex space-x-0 mb-4 items-start flex-col sm:flex-row sm:space-x-3"
          >
            <div className="w-[39px] h-[39px] shrink-0 rounded-lg text-lg flex items-center justify-center bg-[#E1E5F0] mb-3 sm:mb-0">
              {i + 1}
            </div>
            <TextField
              {...r(i)}
              inputProps={{ maxLength: MAX_BULLET_LENGTH }}
              className="w-full"
            />

            <div className="flex items-center h-[39px] pl-[28px]">
              <div className="w-[40px]">
                {i > 0 && bullets.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronUp as any}
                    onClick={() => moveBullet(i, i - 1)}
                    className="-mb-0.5 cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                {i < bullets.length - 1 && bullets.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronDown as any}
                    onClick={() => moveBullet(i, i + 1)}
                    className="cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                <FontAwesomeIcon
                  icon={faClose as any}
                  onClick={() => removeBullet(i)}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>
        );
      })}
      <Button onClick={() => onChange([...bullets, { text: '' }])}>
        Add Bullet
      </Button>
    </section>
  );
}
